// extracted by mini-css-extract-plugin
export default {"mn-move-image-modal":"index_mn-move-image-modal__-dwyS","move-image-modal-content":"index_move-image-modal-content__qw6b6","mn-move-image-repeat":"index_mn-move-image-repeat__q75rH"};